import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from '@mui/material';

// Settings for the "Besonderer Anlass" block: date field, timing relative to
// the occasion (on/before/after + offset days) and yearly recurrence.
const SpecialOccasionSettings = ({ block, readOnly, onConfigChange }) => {
  const config = block.config || {};
  const direction = config.direction || 'on';
  const showOffset = direction === 'before' || direction === 'after';

  const commitOffsetDays = raw => {
    const parsed = parseInt(raw, 10);
    onConfigChange({ offsetDays: Number.isNaN(parsed) ? 0 : Math.max(0, parsed) });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormControl fullWidth size='small'>
        <InputLabel id={`fz-date-field-${block.blockId}`}>Anlass / Datumsfeld</InputLabel>
        <Select
          labelId={`fz-date-field-${block.blockId}`}
          label='Anlass / Datumsfeld'
          value={config.dateField || 'birthdate'}
          disabled={readOnly}
          onChange={event => onConfigChange({ dateField: event.target.value })}
        >
          <MenuItem value='birthdate'>Geburtstag (birthdate)</MenuItem>
        </Select>
      </FormControl>
      <FormControl disabled={readOnly}>
        <FormLabel sx={{ typography: 'body2', mb: 0.5 }}>Zeitpunkt des nächsten Schritts</FormLabel>
        <RadioGroup
          value={direction}
          onChange={event => onConfigChange({ direction: event.target.value })}
        >
          <FormControlLabel value='on' control={<Radio size='small' />} label='sofort am Geburtstag' />
          <FormControlLabel
            value='before'
            control={<Radio size='small' />}
            label='X Tage vor dem Geburtstag'
          />
          <FormControlLabel
            value='after'
            control={<Radio size='small' />}
            label='X Tage nach dem Geburtstag'
          />
        </RadioGroup>
      </FormControl>
      {showOffset && (
        <TextField
          key={`${block.blockId}-offset`}
          size='small'
          type='number'
          label={`Tage ${direction === 'before' ? 'vor' : 'nach'} dem Geburtstag (X)`}
          defaultValue={Number(config.offsetDays) || 0}
          disabled={readOnly}
          inputProps={{ min: 0 }}
          onChange={event => commitOffsetDays(event.target.value)}
          sx={{ maxWidth: 240 }}
        />
      )}
      <FormControl fullWidth size='small'>
        <InputLabel id={`fz-recurrence-${block.blockId}`}>Wiederholung</InputLabel>
        <Select
          labelId={`fz-recurrence-${block.blockId}`}
          label='Wiederholung'
          value={config.recurrence || 'yearly'}
          disabled={readOnly}
          onChange={event => onConfigChange({ recurrence: event.target.value })}
        >
          <MenuItem value='yearly'>Jährlich</MenuItem>
        </Select>
      </FormControl>
      <Typography variant='caption' color='text.secondary'>
        Der Anlass löst jedes Jahr erneut aus.
      </Typography>
    </Box>
  );
};

export default SpecialOccasionSettings;
